import { useAnimations, useGLTF } from "@react-three/drei";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import { useShallow } from "zustand/react/shallow";
import React, { useEffect, useRef } from "react";
import { dispose } from "@react-three/fiber";
import * as THREE from "three";
// import { GLTFExporter } from "three/addons/exporters/GLTFExporter.js";

const Model = (props) => {
  const { scene, animations } = useGLTF(props.modelUrl);
  // const exporter = new GLTFExporter();
  const {
    isNormalized,
    setNormalize,
    setCustomScale,
    isSceneLoaded,
    dataFromProps,
    initialPositionVector,
    setInitialPositionVector,
  } = useThreeJsLoader(
    useShallow((state) => {
      return {
        modelUrl: state.modelUrl,
        isNormalized: state.isNormalized,
        setNormalize: state.setNormalize,
        setCustomScale: state.setCustomScale,
        isSceneLoaded: state.isSceneLoaded,
        dataFromProps: state.dataFromProps,
        initialPositionVector: state.initialPositionVector,
        setInitialPositionVector: state.setInitialPositionVector,
      };
    })
  );
  const modelRef = useRef();
  const hasBeenNormalized = useRef(false);
  const { actions } = useAnimations(animations, modelRef);

  useEffect(() => {
    return () => {
      dispose(scene);
      useGLTF.clear(props.modelUrl);
    };
  }, []);

  useEffect(() => {
    if (Object.keys(actions).length > 0) {
      const modelAnimation = Object.keys(actions)[0];
      actions[modelAnimation].play();
    }
  }, [actions]);

  useEffect(() => {
    if (isSceneLoaded) {
      if (!props.config) {
        if (modelRef.current && !isNormalized) {
          hasBeenNormalized.current = true;
          normalizeModel();
        }
      }
    }
  }, [isSceneLoaded]);

  const normalizeModel = () => {
    setNormalize();
    let centerVector = new THREE.Vector3();
    let sizeVector = new THREE.Vector3();
    let scaleRatio = 1;

    let box3 = new THREE.Box3().setFromObject(modelRef.current, true);
    box3.getCenter(centerVector);
    box3.getSize(sizeVector);

    setInitialPositionVector([
      -centerVector.x,
      -centerVector.y + sizeVector.y / 2,
      -centerVector.z,
    ]);

    if (!dataFromProps.isNormalized) {
      if (sizeVector.x > 1 && sizeVector.x > sizeVector.z) {
        scaleRatio = 1 / sizeVector.x;
      }
      if (sizeVector.z > 1 && sizeVector.z > sizeVector.x) {
        scaleRatio = 1 / sizeVector.z;
      }
      setCustomScale(scaleRatio);
    }
  };

  // // 'text/plain' "application/octet-stream"
  // function saveArrayBuffer(buffer, filename) {
  //   // gltf
  //   // const test = new Blob([buffer], { type: "text/plain" });
  //   // glb
  //   const test = new Blob([buffer], { type: "application/octet-stream" });
  //   // console.log("test blob =>", test);
  //   save(test, filename);
  // }

  // const link = document.createElement("a");
  // link.style.display = "none";
  // document.body.appendChild(link); // Firefox workaround, see #6594

  // function save(blob, filename) {
  //   link.href = URL.createObjectURL(blob);
  //   link.download = filename;
  //   link.click();

  //   // URL.revokeObjectURL( url ); breaks Firefox...
  // }

  // useEffect(() => {
  //   setTimeout(() => {
  //     const exporter = new GLTFExporter();
  //     // console.log("test =>", modelRef.current);
  //     exporter.parse(
  //       modelRef.current,
  //       function (result) {
  //         // console.log("result =>", result);

  //         // gltf
  //         // const output = JSON.stringify(result, null, 2);
  //         // saveArrayBuffer(output, "testCustom.gltf");

  //         // glb
  //         saveArrayBuffer(result, "testCustomGlb.glb");
  //       },
  //       function (error) {
  //         console.log("An error happened =>", error);
  //       },
  //       // gltf
  //       // { binary: false, includeCustomExtensions: true }
  //       // glb
  //       { binary: true, includeCustomExtensions: true, onlyVisible: true }
  //     );
  //   }, 3000);
  // }, [scene, exporter]);

  return (
    <primitive
      object={scene}
      ref={modelRef}
      scale={props.config ? props.configScale : [1, 1, 1]}
      position={props.config ? props.configPosition : initialPositionVector}
    />
  );
};

export default Model;
